module.exports = __webpack_public_path__ + "static/media/homepage_logo2.c4edb1ad.png";